import { PluginApprovalStatus } from "@fuse/recoil/plugins"

/**
 * Centralized configuration for plugin defaults
 *
 * IMPORTANT: Change these values to control the default behavior for plugins
 */
export const PLUGIN_DEFAULTS_CONFIG = {
  /**
   * Default approval status for example plugins when saved
   *
   * Options:
   * - PluginApprovalStatus.PRIVATE: Plugin is private to the creator
   * - PluginApprovalStatus.AWAITING_REVIEW: Plugin needs review before public use
   * - PluginApprovalStatus.REVIEW_APPROVED: Plugin has been reviewed and approved
   * - PluginApprovalStatus.CERTIFIED: Plugin is certified for public use
   * - PluginApprovalStatus.LETS_HANG_OWNED: Plugin is owned by Let's Hang (enables instant add/remove)
   */
  DEFAULT_APPROVAL_STATUS: PluginApprovalStatus.LETS_HANG_OWNED,

  /**
   * Whether to automatically mark example plugins as zero-config by default
   *
   * When true: All example plugins will be marked as zero-config regardless of content
   * When false: Only plugins with detected zero-config patterns will be marked as zero-config
   */
  AUTO_MARK_EXAMPLES_AS_ZERO_CONFIG: true,

  /**
   * Whether to enable automatic zero-config detection based on host config content
   *
   * When true: Analyzes the host config view code to determine if it's zero-config
   * When false: Relies only on manual settings or AUTO_MARK_EXAMPLES_AS_ZERO_CONFIG
   */
  ENABLE_AUTO_ZERO_CONFIG_DETECTION: true,

  /**
   * Whether to apply auto-detection to all saved plugins (not just examples)
   *
   * When true: All plugins will be analyzed for zero-config patterns when saved
   * When false: Only example plugins will be auto-analyzed
   */
  APPLY_AUTO_DETECTION_TO_ALL_PLUGINS: true,
}

/**
 * Quick toggle to disable all automatic behavior
 * Set this to false to disable all automatic approval status and zero-config detection
 */
export const ENABLE_AUTOMATIC_PLUGIN_CONFIGURATION = true

/**
 * Helper function to get effective configuration
 * Returns disabled config if ENABLE_AUTOMATIC_PLUGIN_CONFIGURATION is false
 */
export const getEffectivePluginConfig = () => {
  if (!ENABLE_AUTOMATIC_PLUGIN_CONFIGURATION) {
    return {
      DEFAULT_APPROVAL_STATUS: PluginApprovalStatus.PRIVATE,
      AUTO_MARK_EXAMPLES_AS_ZERO_CONFIG: false,
      ENABLE_AUTO_ZERO_CONFIG_DETECTION: false,
      APPLY_AUTO_DETECTION_TO_ALL_PLUGINS: false,
    }
  }

  return PLUGIN_DEFAULTS_CONFIG
}
